function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Component, createElement } from 'react';
import PropTypes from 'prop-types';
import { withThemeFactory, THEME_CHANNEL } from 'fela-bindings';

export default withThemeFactory(Component, createElement, _defineProperty({}, THEME_CHANNEL, PropTypes.object));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/style-container/node_modules/react-fela/es/withTheme.js
// module id = 118
// module chunks = 0